import React, { useEffect } from "react";
import {
  clearSession,
  hasLiveSession,
  navigateToUserStoreSignedIn,
  safeNext,
} from "../helpers/global";
import { Loader } from "../components/Loader";

const CheckValidty = ({ children }) => {
  const isRegister = window.location.pathname.search("register") === 1;
  const live = hasLiveSession();

  useEffect(() => {
    if (!isRegister && live) {
      // Same one-time link as a fresh login, so coming back to /login with a
      // valid session lands in the store admin rather than at its login form.
      const next = safeNext();
      if (next) {
        window.location.replace(next);
      } else {
        navigateToUserStoreSignedIn();
      }
    }
  }, [isRegister, live]);

  if (isRegister) {
    return children;
  }

  if (!live) {
    // Drop whatever is left over, or the next visit redirects again.
    clearSession();

    return children;
  }

  return (
    <>
      <Loader />
    </>
  );
};

export default CheckValidty;
